import { LOAD_APP, DATA_ALREADY_LOADED } from './actionTypes'

export const loadApp = () => ({
  type: LOAD_APP,
})

export const dataAlreadyLoaded = () => ({
  type: DATA_ALREADY_LOADED,
})
